import styled from 'styled-components';
import { EditorContent } from '@tiptap/react';

export const ErrorContainer = styled.div`
  text-align: center;
  padding: 8px;
  background-color: ${({ theme }) => theme.palette.error.light};
  border-radius: 4px;
  margin: 8px 0;
  border: 1px solid ${({ theme }) => theme.palette.error.main};

  span {
    color: ${({ theme }) => theme.palette.error.main};
    font-weight: 500;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
`;

export const Sidebar = styled.div<{ $isScrolledDown?: boolean }>`
  position: fixed;
  right: 80px;
  top: 200px;
  width: 320px;
  max-height: calc(100vh - 220px);
  overflow-y: auto;
  min-width: 300px;
  border-radius: 8px;
  padding-bottom: 12px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  background: ${({ theme }) => theme.palette.common.white};
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);

  z-index: 1000;
`;

export const ReadOnlyEditorContent = styled(EditorContent)`
  .tiptap[class*='tiptap-pages-'] {
    position: relative;
    isolation: isolate;
    margin-inline: auto;
    border-left: 0 !important;
    border-right: 0 !important;
    border-top: 1px solid ${({ theme }) => theme.palette.divider} !important;
    border-bottom: 1px solid ${({ theme }) => theme.palette.divider} !important;
    box-shadow: none !important;

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      width: 1px;
      background-color: ${({ theme }) => theme.palette.divider};
      pointer-events: none;
      z-index: 100;
    }

    &::before {
      left: 1px;
    }

    &::after {
      right: 1px;
    }
  }

  .tiptap[class*='tiptap-pages-'] .breaker {
    z-index: auto !important;
  }

  .tiptap[class*='tiptap-pages-'] .tiptap-pagination-gap {
    z-index: 101;
    border-left: 0 !important;
    border-right: 0 !important;
    border-top: 1px solid ${({ theme }) => theme.palette.divider} !important;
    border-bottom: 1px solid ${({ theme }) => theme.palette.divider} !important;
    background-color: ${({ theme }) => theme.palette.common.white} !important;
  }

  // Pages dims every [contenteditable=false] body to mark it inactive while a header/footer
  // overlay is open. Read-only editors are always non-editable, so undo it there.
  .tiptap[class*='tiptap-pages-'][contenteditable='false'] * {
    opacity: 1;
    user-select: text;
    cursor: auto;
  }
`;
